export default {
  accountLocked: {
    id: 'asp_action_bar_problem_declaration_message_step_subtitle_account_locked',
    defaultMessage: 'Item locked to iCloud / Google',
  },
  codeLocked: {
    id: 'asp_action_bar_problem_declaration_message_step_subtitle_code_locked',
    defaultMessage: 'Item is code / pattern locked',
  },
  missingPart: {
    id: 'asp_action_bar_problem_declaration_message_step_subtitle_missing_part',
    defaultMessage: 'Missing part / accessories',
  },
  other: {
    id: 'asp_action_bar_problem_declaration_message_step_subtitle_other',
    defaultMessage: 'Other',
  },
  problemNotIdentified: {
    id: 'asp_action_bar_problem_declaration_message_step_subtitle_problem_not_identified',
    defaultMessage: 'Problem reported couldn’t be identified',
  },
  wrongItem: {
    id: 'asp_action_bar_problem_declaration_message_step_subtitle_wrong_item',
    defaultMessage: 'Wrong item received',
  },
}
